import React, { useState, useEffect, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import SideBar from '../../Components/Sidebar'
import Pageheader from "../Container/PageHeader/Pageheader"
import "./Profile.css"
import LeftArrow from "../../Assests/Chevron.svg"
import Tick from "../../Assests/Tick.svg"
import xIcon from "../../Assests/X.svg"
import editIcon from "../../Assests/edit.svg"
import Switch from "../../Components/switch"
import SearchBar from "../../Components/Searchbar";
import Insta from "../../Assests/Insta.svg"
import LinkedIn from "../../Assests/Linkedin.svg"
import Facebook from "../../Assests/Facebook.svg"
import Spotify from "../../Assests/Spotify.svg"
import { capitalizeNames } from '../../utils/nameUtils'
import Youtube from "../../Assests/Youtube.svg"
import Link from "../../Assests/Link.svg"
import { InterestTopics } from "../../Constants/InterestTopics"
import { setDataValue, clearData } from '../../redux/dataSlice'
import LinkDialog from '../../Components/linkDialog'
import { information, getUserProfileDetails } from '../../Services/ShowsApi'
import { useNavigate } from 'react-router-dom'
import { API_STATUS } from '../../utils/constant'
import { setData } from '../../redux/userSlice'
import { useLoader } from '../../Components/LoaderContext'
import { updateProfilePicture, updateUserName } from '../../utils/CometChatCommon'
import { FormControl, FormLabel, TextField } from '@mui/material';


const Profile = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const tempData = useSelector((state) => state.data);
    const user = useSelector((state) => state?.user || []);
    const { UserID, FirstName, LastName,
    } = user || {};
    const { triggerLoader, hideLoader } = useLoader();
    const [isFormValid, setIsFormValid] = useState(false);
    const [formErrors, setFormErrors] = useState({
        firstName: '',
        lastName: '',
        topics: ''
    });
    console.log(typeof (FirstName), LastName)
    useEffect(() => {
        const errors = {
            firstName: !tempData?.FirstName?.trim() ? 'First name is required' :
                tempData?.firstNameError || '',
            lastName: !tempData?.LastName?.trim() ? 'Last name is required' :
                tempData?.lastNameError || '',
            topics: !tempData?.Topics?.length ? 'Please select at least one topic' : ''
        };
        setFormErrors(errors);
        setIsFormValid(
            // FirstName.length>0&&LastName.length>0

            tempData?.FirstName?.trim() !== "" &&
            // !tempData?.firstNameError &&
            tempData?.LastName?.trim() !== "" &&
            // !tempData?.lastNameError &&
            tempData?.Topics?.length > 0
        );
    }, [tempData]);

    const handleSave = async () => {
        if (!isFormValid) {
            alert('Please complete all required fields correctly before saving');
            return;
        }

        const { item_id, firstNameError, lastNameError, ...restPayload } = tempData;
        const payloadWithUser = {
            ...restPayload,
            UserID: UserID,
        };

        triggerLoader("Updating profile...");

        try {
            if (tempData?.ProfileImage) {
                try {
                    await Promise.race([
                        updateProfilePicture("data:image/png;base64," + tempData?.ProfileImage),
                        new Promise((_, reject) => 
                            setTimeout(() => reject(new Error("Profile picture update timeout")), 10000)
                        )
                    ]);
                    console.log("Profile picture updated");
                } catch (avatarError) {
                    console.log("Profile picture update failed, continuing:", avatarError.message);
                }
            }

            // Update profile information
            let firstName = tempData?.FirstName || FirstName;
            let lastName = tempData?.LastName || LastName;
            let newName = capitalizeNames(firstName, lastName).fullName;
            console.log("newName", newName);
            let res = await information(payloadWithUser);
            try {
                await Promise.race([
                    updateUserName(capitalizeNames(firstName, lastName).fullName),
                    new Promise((_, reject) => 
                        setTimeout(() => reject(new Error("CometChat operation timeout")), 8000)
                    )
                ]);
                console.log("CometChat username updated");
            } catch (cometChatError) {
                console.log("CometChat username update failed, continuing with profile update:", cometChatError.message);
            }
            
            if (res?.status == API_STATUS.success) {
                const { data } = await getUserProfileDetails("UserID");
                const { Data } = data?.body || {};
                const updatedUserData = Data?.[0];
                localStorage.setItem('user_profile_data', JSON.stringify(updatedUserData));
                dispatch(setData(updatedUserData));
                navigate(-1);
            } else {
                alert('Failed to update profile. Please try again.');
            }
        } catch (error) {
            alert('An error occurred while updating your profile. Please try again.');
        } finally {
            hideLoader();
        }
    }

    const handleCancel = () => {
        navigate(-1);
    }

    return (
        <>
            <div className='theme-bg clr-white height-100' style={({ display: "flex" })}>
                <SideBar></SideBar>
                <div className='container-fluid overflow-x-none ml-80p'>
                    <div className='row'>
                        <div className="container" style={{ minHeight: "100vh", color: "#fff" }}>
                            <div>
                                <Pageheader pageTitle="Your Profile" />
                            </div>
                            <div className='profilepage_container'>
                                <div className='profilepage_container_edit'>
                                    <div className='profilepage_container_editTitle'>
                                        <img src={LeftArrow} onClick={handleCancel} />
                                        <span>Editing</span>
                                    </div>
                                    <div className='profilepage_container_editButton'>
                                        <div className='profilepage_container_cancelButton' onClick={handleCancel}>
                                            <span>Discard</span>
                                            <img src={xIcon} />
                                        </div>
                                        <div className='profilepage_container_saveButton'
                                            onClick={isFormValid ? handleSave : () => alert('Please fill all required fields')}
                                            style={{
                                                opacity: isFormValid ? 1 : 0.5,
                                                cursor: isFormValid ? 'pointer' : 'not-allowed'
                                            }}>
                                            <span>Save</span>
                                            <img src={Tick} />
                                        </div>
                                    </div>
                                </div>
                                <div className='profilepage_container_main'>
                                    <div className='profilepage_container_info'>
                                        <UserInfo />
                                        <UserBio InterestTopics={InterestTopics} />
                                        <UserSocial />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


const UserInfo = () => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state?.user || []);
    const {
        UserID,
        FirstName, LastName,
        Collaborate, connectionCount,
        connectionProfile,
        FacebookLink,
        InstagramLink,
        LinkedinLink,
        SpotifyLink,
        YoutubeLink,
        ProfileImageKey,
        Bio,
        Topics,
        Rate } = user || {};

    const [isOpenToCollaborate, setIsOpenToCollaborate] = useState(Collaborate === 1);
    const [firstName, setFirstName] = useState(FirstName || "");
    const [lastName, setLastName] = useState(LastName || "");
    const [image, setImage] = useState(ProfileImageKey || null);
    const [rate, setRate] = useState(Rate || "00");
    const [picError, setPicError] = useState("");
    const [errors, setErrors] = useState({
        firstName: '',
        lastName: ''
    });

    const validateName = (name, fieldName) => {
        if (!name.trim()) {
            return `${fieldName} is required`;
        }
        if (name.length > 50) {
            return `${fieldName} must be less than 50 characters`;
        }
        if (!/^[a-zA-Z\s-']+$/.test(name)) {
            return `${fieldName} contains invalid characters`;
        }
        return '';
    };

    const handleUserNameChange = (field, value) => {
        const error = validateName(value, field === 'firstName' ? 'First name' : 'Last name');

        if (field === 'firstName') {
            setFirstName(value);
        } else {
            setLastName(value);
        }

        dispatch(setDataValue({
            [field === 'firstName' ? 'FirstName' : 'LastName']: value,
            [`${field}Error`]: error
        }));
    };

    const toggleSwitch = async () => {
        dispatch(setDataValue({ Collaborate: !isOpenToCollaborate }));
        setIsOpenToCollaborate(!isOpenToCollaborate)
    };

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const maxSizeInBytes = 2 * 1024 * 1024;
            if (file.size > maxSizeInBytes) {
                setPicError("Image must be under 2MB!")
                return;
            }
            setPicError("");
            const reader = new FileReader();
            let prefix = "data:image/png;base64,";

            reader.onloadend = () => {
                setImage(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleRateChange = (value) => {
        if (!isNaN(value)) {
            setRate(value);
            dispatch(setDataValue({ Rate: value }));
        }
    }

    useEffect(() => {
        let prefix = "data:image/png;base64,";
        if (image?.startsWith("data:image/jpeg")) {
            prefix = "data:image/jpeg;base64,";
        }
        const base64 = image?.substring(prefix.length);

        if (base64) {
            dispatch(setDataValue({ ProfileImage: base64 }));
        }
    }, [image]);

    useEffect(() => {
        dispatch(clearData());
    }, [])

    return (
        <div className='userinfo_main_container'>
            <div className='userinfo_container'>
                <div className='userinfo_img_container'>
                    <div className='user_profileinfo_title'>Change Profile Picture</div>
                    <div className='userinfo_profileImage_container'>
                        <label htmlFor="profile-upload" className="profileimg_edit">
                            <img src={image} />
                            <div className='userinfo_profileImage_edit'>
                                <img src={editIcon} />
                            </div>
                        </label>
                        <input
                            type="file"
                            id="profile-upload"
                            accept="image/*"
                            onChange={handleImageChange}
                            style={{ display: "none" }}
                        />
                    </div>
                    {/* <span className="error-message">{picError}</span> */}
                </div>
                <div className='userinfo_data_container'>
                    <div className='userinfo_data_containerTop'>
                        <div className='userinfo_data_containerTop_edit'>
                            <span className='user_profileinfo_title'>Edit your Firstname</span>
                            <FormControl fullWidth>
                                <FormLabel sx={{ color: '#FFFFFF', fontSize: '1.4vh', fontWeight: '100', marginLeft: '1.2vh' }}>
                                    First Name <span style={{ color: 'red',fontSize: '1.4vh',  }}>*</span>
                                </FormLabel>
                                <TextField
                                    value={firstName}
                                    placeholder='Enter First Name'
                                    onChange={(e) => handleUserNameChange('firstName', e.target.value)}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '1.6vh',
                                            height: '5vh',                
                                            fontSize: '1.4vh', 
                                            paddingRight: '0.8vw',
                                            display: 'flex',
                                            alignItems: 'center',
                                            '& fieldset': {
                                                borderColor: '#FFFFFF',
                                            },
                                            '&:hover fieldset': {
                                                borderColor: '#FFFFFF',
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: '#FFFFFF',
                                            },
                                        },
                                        '& input::placeholder': {
                                            fontSize: '1.2vh',
                                            color: '#CCCCCC',
                                            opacity: 1,
                                        },
                                    }}
                                    error={!!errors.firstName}
                                    required
                                    title="Please fill out this required field"
                                />
                            </FormControl>
                            {errors.firstName && (
                                <span className="error-message">{errors.firstName}</span>
                            )}
                        </div>
                        <div className='userinfo_data_containerTop_edit'>
                            <span className='user_profileinfo_title'>Edit your Lastname</span>
                            <FormControl fullWidth>
                                <FormLabel
                                    sx={{ color: '#FFFFFF', fontSize: '1.4vh', fontWeight: '100', marginLeft: '1.2vh' }}
                                >
                                    Last Name <span style={{ color: 'red', fontSize: '1.4vh' }}>*</span>
                                </FormLabel>
                                <TextField
                                    value={lastName}
                                    placeholder='Enter Last Name'
                                    onChange={(e) => handleUserNameChange('lastName', e.target.value)}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '1.6vh',
                                            height: '5vh',                
                                            fontSize: '1.4vh', 
                                            paddingRight: '0.8vw',
                                            display: 'flex',
                                            alignItems: 'center',
                                            '& fieldset': {
                                                borderColor: '#FFFFFF',
                                            },
                                            '&:hover fieldset': {
                                                borderColor: '#FFFFFF',
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: '#FFFFFF',
                                            },
                                        },
                                        '& input::placeholder': {
                                            fontSize: '1.2vh',
                                            color: '#CCCCCC',
                                            opacity: 1,
                                        },
                                    }}
                                    error={!!errors.lastName}
                                    required
                                    title="Please fill out this required field"
                                />
                            </FormControl>
                            {errors.lastName && (
                                <span className="error-message">{errors.lastName}</span>
                            )}
                        </div>
                    </div>
                    <div className='userinfo_data_containerBottom'>
                        <div className='userinfo_data_containerBottom_left'>
                            <div className='userinfo_data_containerBottom_left_top'>
                                <span className='user_profileinfo_title'>Thinking about switching up how you collaborate?</span>
                                <span className='user_profileinfo_subtitle'>Change this preference anytime to show how you like to collaborate!</span>
                            </div>
                            <div className='userinfo_data_containerBottom_collab'>
                                <Switch isOn={isOpenToCollaborate} toggleSwitch={toggleSwitch} />
                                <span>{isOpenToCollaborate ? "Open" : "Closed"} to Collaboration</span>
                            </div>
                        </div>
                        <div className='userinfo_data_containerBottom_right'>
                            <div className='userinfo_data_containerBottom_right_top'>
                                <span className='user_profileinfo_title'>Change your collaboration rate</span>
                                <span className='user_profileinfo_subtitle'>Feel free to adjust the collaboration rate anytime!</span>
                            </div>
                            <div className='userinfo_data_containerBottom_rate'>
                                <span>Hourly rate</span>
                                <div className='userinfo_data_containerBottom_rate_data'>
                                    <span>$</span>
                                    <div className='userinfo_data_containerBottom_rate_value'>
                                        <div >
                                            <input value={rate} onChange={(e) => handleRateChange(e.target.value)} />
                                        </div>
                                        <span>/Hr</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="userinfo_img_container_error"> */}
            <span className="userinfo_img_container_error">{picError}</span>
        </div>
    )
}

const UserBio = ({ InterestTopics }) => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state?.user || []);
    const {
        UserID,
        FirstName, LastName,
        Collaborate, connectionCount,
        connectionProfile,
        FacebookLink = "",
        InstagramLink,
        LinkedinLink,
        SpotifyLink,
        YoutubeLink,
        ProfileImageKey,
        Bio,
        Topics } = user || {};

    const parsedTopics = useMemo(() => {
        try {
            if (Array.isArray(Topics)) {
                return Topics;
            }
            if (typeof Topics === 'string') {
                const cleanedTopics = Topics
                    .replace(/^'|'$/g, '')
                    .replace(/'/g, '"');
                return JSON.parse(cleanedTopics);
            }
            return [];
        } catch (error) {
            console.error('Error parsing topics:', error);
            return [];
        }
    }, [Topics]);

    const [selectedTopics, setSelectedTopics] = useState(parsedTopics);
    const [searchTerm, setSearchTerm] = useState("");
    const [bio, setBio] = useState(Bio || "");
    const [customTopics, setCustomTopics] = useState([]);
    const [topicError, setTopicError] = useState("");

    let count = selectedTopics ? selectedTopics?.length : 0;

    const handleChange = (e) => {
        if (e.target.value.length <= 300) {
            setBio(e.target.value);
        }
    };

    const removeSelectedTopic = (topic) => {
        const newTopics = selectedTopics.filter((item) => item !== topic);
        setSelectedTopics(newTopics);
        validateTopics(newTopics);
    };

    const toggleTopicSelection = (topic) => {
        const newTopics = selectedTopics.includes(topic)
            ? selectedTopics.filter((t) => t !== topic)
            : selectedTopics.length < 5
                ? [...selectedTopics, topic]
                : selectedTopics;

        setSelectedTopics(newTopics);
        validateTopics(newTopics);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            const newTopic = searchTerm.trim();
            if (
                newTopic &&
                !selectedTopics.includes(newTopic) &&
                !customTopics.includes(newTopic) &&
                selectedTopics.length < 5
            ) {
                const newTopics = [...selectedTopics, newTopic];
                setCustomTopics((prev) => [...prev, newTopic]);
                setSelectedTopics(newTopics);
                validateTopics(newTopics);
            }
            setSearchTerm("");
        }
    };

    const validateTopics = (topics) => {
        if (topics.length === 0) {
            setTopicError("Please select at least one interest topic");
            return false;
        }
        setTopicError("");
        return true;
    };

    useEffect(() => {
        validateTopics(selectedTopics);
        dispatch(setDataValue({ Topics: selectedTopics || JSON.parse(Topics) }));
    }, [selectedTopics]);

    useEffect(() => {
        if (bio.trim() === "") {
            dispatch(setDataValue({ Bio: Bio }));
        } else {
            dispatch(setDataValue({ Bio: bio }));
        }
    }, [bio]);

    return (
        <div className='userbio_container'>
            <div className='userbio_sub_container'>
                <div className='userbio_sub_container_top'>
                    <span className='user_profileinfo_title'>Update your bio</span>
                    <span className='user_profileinfo_subtitle'>You can easily update this bio whenever you need to.</span>
                </div>
                <div className='userbio_sub_container_bio'>
                    <textarea
                        className="userbio_data"
                        value={bio}
                        onChange={(e) => handleChange(e)}
                        placeholder="Write your bio..."
                    />
                    <div className="userbio_data_length">{bio?.length}/300</div>
                </div>
            </div>
            <div className='userbio_sub_container'>
                <div>
                    <span className='user_profileinfo_title'>Modify your selected topics here.</span>
                </div>
                <div className='userbio_sub_container_topics'>
                    <div className='userbio_sub_container_selected_topics'>
                        <div className='userbio_sub_container_topics_title'>
                            <span>Your Selected Topics</span>
                            <span>{count}/5</span>
                        </div>
                        <div className="userbio_sub_container_topics_search">
                            <SearchBar
                                placeholder="Search"
                                searchTerm={searchTerm}
                                setSearchTerm={setSearchTerm}
                                handleKeyDown={handleKeyDown}
                                customStyles={{ padding: '0' }}
                            />
                            {topicError && (
                                <div className="topic-error-message">{topicError}</div>
                            )}
                        </div>
                        <div className='userbio_sub_container_selected_topics_items'>
                            {selectedTopics?.map((topic, index) => (
                                <div key={index} className="selected_topic">
                                    <span className="topic" onClick={() => removeSelectedTopic(topic)}>{topic}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className='userbio_sub_container_rec_topics'>
                        <span className='userbio_sub_container_topics_title'>
                            Recommended for You
                        </span>
                        <div className='userbio_sub_container_rec_topics_items'>
                            {InterestTopics.map((topic, index) => (
                                <button
                                    className='selectedTag'
                                    key={index}
                                    onClick={() => toggleTopicSelection(topic)}
                                >
                                    <div className="rec_topic">{topic}</div>
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const UserSocial = () => {
    const dispatch = useDispatch();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [platform, setPlatform] = useState({ name: "", key: "", link: "" });

    const user = useSelector((state) => state?.user || []);
    const [userProfile, setUserProfile] = useState(user || {});

    const [socialPlatforms, setSocialPlatforms] = useState([
        { name: "Facebook", key: "FacebookLink", icon: Facebook, link: "" },
        { name: "Spotify", key: "SpotifyLink", icon: Spotify, link: "" },
        { name: "Instagram", key: "InstagramLink", icon: Insta, link: "" },
        { name: "LinkedIn", key: "LinkedinLink", icon: LinkedIn, link: "" },
        { name: "YouTube", key: "YoutubeLink", icon: Youtube, link: "" },
    ]);

    const handleSelect = (name, key, link) => {
        setPlatform({ name, key, link });
        if (link) {
            setUserProfile(prev => ({
                ...prev,
                [key]: "",
            }));
            dispatch(setDataValue({ [key]: "" }));
        } else {
            setIsModalOpen(true);
        }
    };

    const handleSave = () => {
        if (platform.link.trim() !== "") {
            dispatch(setDataValue({ [platform.key]: platform.link }));
        }
        setIsModalOpen(false);
    };

    const handlePlatformLink = (value) => {
        setPlatform((prev) => ({ ...prev, link: value }));
        setSocialPlatforms((prevPlatforms) =>
            prevPlatforms.map((item) =>
                item.name === platform.name ? { ...item, link: value } : item
            )
        );
    }

    return (
        <>
            <div className='usersocial_container'>
                <div className='usersocial_sub_container'>
                    <span className='user_profileinfo_title' >Which social media accounts would you like to link or unlink?</span>
                    <span className='usersocial_subTitle' >
                        you can connect additional social media accounts or remove existing one to help collaborators discover your work more easly.
                        Feel free to make changes anytime in your profile settings.
                    </span>
                </div>
                <div className='usersocial_profile_container'>
                    {socialPlatforms?.map(({ name, key, icon, link }) => (
                        <div key={name} className="usersocial_profile_container_item" onClick={() => handleSelect(name, key, link || userProfile[key])}>
                            <div className="usersocial_profile_item_img">
                                <img src={icon} alt={`${name} icon`} />
                            </div>
                            <div className="usersocial_profile_status_button">
                                <div className={userProfile[key] ? "usersocial_profile_unlink" : "usersocial_profile_item_status"}>
                                    <span>{userProfile[key] ? "Unlink" : "Link"}</span>
                                    {!userProfile[key] && <img src={Link} alt="link icon" />}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <LinkDialog
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onConfirm={handleSave}
                title={`Edit ${platform?.name} Link`}
                inputValue={platform?.link}
                setInputValue={(value) => handlePlatformLink(value)}
            />
        </>
    )
}

export default Profile;


